import { 
	SET_CURRENT_USER,
	CLEAR_CURRENT_USER
 } from './types';

const initialState = {
	isAuthenticated: false,
	user: {}
};

export default function(state = initialState, action) {
	switch (action.type) {
		case SET_CURRENT_USER:
			return {
				...state,
				isAuthenticated: true,
				user: action.payload
			};
		case CLEAR_CURRENT_USER:
			return {
				...state,
				isAuthenticated: false,
				user: {}
			};

		default:
			return state;
	}
}